import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import BookAppointment from "@/pages/BookAppointment";
import Confirmation from "@/pages/Confirmation";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/book" element={<BookAppointment />} />
      <Route path="/confirmation/:reference" element={<Confirmation />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}
